module.exports = __webpack_public_path__ + "img/-h-橙色.acebde87.png";